import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Remarkable from 'remarkable'

import NotYetSpecified from './NotYetSpecified'

export default class MarkdownLabel extends PureComponent {
  render() {
    const { id, value, additionalCssClasses } = this.props
    const isMissingValue = !value || value === ''

    if (isMissingValue) {
      return <NotYetSpecified />
    } else {
      return (
        <label
          id={id}
          className={'markdown ' + additionalCssClasses}
          dangerouslySetInnerHTML={this.rawMarkup(value)}
        ></label>
      )
    }
  }

  rawMarkup(val) {
    var md = new Remarkable({ linkTarget: '_blank' })
    return { __html: md.render(val) }
  }
}

MarkdownLabel.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  additionalCssClasses: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/MarkdownLabel.js